export const operationsText = {
    POST: 'criar {{target}}.',
    PUT: 'atualizar {{target}}.',
    PATCH: 'atualizar {{target}}.',
    GET: 'encontrar {{target}}.',
    DELETE: 'remover {{target}}.'
} as const;
